export default __webpack_public_path__ + "static/blob7-022ee16dbe3af7038415ae403f9746b2.svg";